import { StyleStateEnum } from '../../PageBuilder/enums/style-state.enum';

enum BriefingStyleState {
    // DEFAULT is deprecated now, it is equivalent to BRIEFING_1
    BRIEFING_1 = 'BRIEFING_1',
    BRIEFING_2 = 'BRIEFING_2',
    BRIEFING_3 = 'BRIEFING_3',
    CANVAS_1 = 'CANVAS_1'
}

export type BriefingStyleStateEnum = StyleStateEnum | BriefingStyleState;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const BriefingStyleStateEnum = {
    ...StyleStateEnum,
    ...BriefingStyleState
};
